module.exports = __webpack_public_path__ + "static/programming_code_1-85d0046db95b8032be5be8e9919ee957.svg";